import type { CSSProperties, MouseEvent } from 'react';

import { haptic, type Haptic } from '../../lib/telegram';

/**
 * Press feedback (DESIGN → Motion, T-1310): shrinks to 0.96 while held and springs back.
 * For any tappable element; `Button` has it built in. Reduced motion keeps only opacity.
 */
export const pressable = 'transition-[transform,opacity] duration-100 ease-spring active:scale-96';

/**
 * List items pop in one after another (T-1311): the first few are staggered by 40 ms, the rest
 * share the last delay so a long list does not keep the reader waiting.
 */
export function popIn(index: number): { className: string; style: CSSProperties } {
	return {
		className: 'animate-pop',
		style: { animationDelay: `${String(Math.min(index, 5) * 40)}ms` },
	};
}

/** Wraps a click handler with a Telegram haptic (`light` by default; `false` = none). */
export function withHaptic<E extends Element>(
	onClick: ((event: MouseEvent<E>) => void) | undefined,
	kind: Haptic | false = 'light',
): (event: MouseEvent<E>) => void {
	return (event) => {
		if (kind !== false) haptic(kind);
		onClick?.(event);
	};
}
